import React from 'react';
import { QuestionLong } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_audio_id, ...props }) => (
  <QuestionLong
    {...props}
    audioSource={generateUrl(file_audio_id)}
  />
);